import React from "react";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";

const WorldMap = () => {
	const data = window.map;

	const maxBounds = [
		[-90, -180],
		[90, 180]
	];


	data.forEach(marker => {
		if (!marker.coordinates) { return; }

		// Format coordinates
		const coordinates = marker.coordinates.split(',');
		const lat = Number(coordinates[0].trim());
		const lng = Number(coordinates[1].trim());
		marker.coordinates = [lat, lng];
	});

	const sections = data.map((marker) => {
		return {
			position: marker.coordinates, 
			name: marker.name,
			address: marker.partner.map_address,
			phone: marker.partner.map_phone,
			email: marker.partner.map_email,
			website: marker.partner.map_web
		}
	})

	return (
		<div style={{height: '600px', width: '100%' }}>
			<MapContainer 
				center={[40, 0]} 
				zoom={2} 
				style={{ height: '100%', width: '100%' }}
				dragging={true}
				scrollWheelZoom={false}
				doubleClickZoom={false}
				zoomControl={false}
				maxBounds={maxBounds}
			>
				<TileLayer
					url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
					attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
				/>
				{sections.map((section, index) => (
					<Marker key={index} position={section.position}> 
						<Popup>
							<h2>{section.name}</h2>
							<p>
								T <a href={`tel:${section.phone.trim()}`}>{section.phone}</a>
							</p>
							<p>
								E <a href={`mailto:${section.email}`}>{section.email}</a>
							</p>
							{
								section.website ?
								<p> 
									W <a href={`${section.website}`}>{section.website}</a>
								</p>
								: null
							}
						</Popup>
					</Marker>
				))}
			</MapContainer>
		</div>
	)
}

export default WorldMap;